import { SelectedShippingRateSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import { dimensionUnits } from "@redotech/redo-fulfillment-measurements-common/dimension-conversion";
import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { RateSchema } from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import {
  consolidationCartonIdFormat,
  consolidationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const consolidationCartonLabelParcelSchema = z.object({
  height: z.number().positive(),
  length: z.number().positive(),
  dimensionUnit: z.enum(dimensionUnits),
  weight: WeightSchema.extend({ value: z.number().positive() }),
  width: z.number().positive(),
});
export type ConsolidationCartonLabelParcel = z.infer<
  typeof consolidationCartonLabelParcelSchema
>;

const consolidationCartonLabelInputSchema = z.object({
  cartonId: consolidationCartonIdFormat.schema,
  consolidationId: consolidationIdFormat.schema,
});

export const consolidationCartonLabelOriginSchema = z.discriminatedUnion(
  "kind",
  [
    z.object({
      kind: z.literal("location"),
      locationId: locationIdFormat.schema,
    }),
    z.object({
      address: FulfillmentOrderAddressSchema,
      kind: z.literal("address"),
    }),
  ],
);
export type ConsolidationCartonLabelOrigin = z.infer<
  typeof consolidationCartonLabelOriginSchema
>;

export const consolidationCartonPurchasedLabelSchema = z.object({
  labelUrl: z.string(),
  redoShipmentId: z.string(),
  trackingNumber: z.string(),
});
export type ConsolidationCartonPurchasedLabel = z.infer<
  typeof consolidationCartonPurchasedLabelSchema
>;

export const prepareConsolidationCartonLabel = {
  name: "prepareConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    destination: FulfillmentOrderAddressSchema.optional(),
    origin: consolidationCartonLabelOriginSchema.optional(),
    parcel: consolidationCartonLabelParcelSchema.optional(),
  }),
  output: z.object({
    purchasedLabel: consolidationCartonPurchasedLabelSchema.nullable(),
    rates: z.array(RateSchema),
  }),
};

export const purchaseConsolidationCartonLabel = {
  name: "purchaseConsolidationCartonLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    shipmentRate: SelectedShippingRateSchema,
  }),
  output: consolidationCartonPurchasedLabelSchema,
};

export const printConsolidationCartonShippingLabel = {
  name: "printConsolidationCartonShippingLabel" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend({
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
  }),
  output: z.object({ url: z.string() }),
};
